<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.29</b> - Кнопка "Продать всё" в магазине, групповые стартовые забеги Пещеры, перемещение
      сумок с предметами в них, исправления ИИ и багов, и немного баланса для полноты картины
      :)
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Пещеры: герои теперь начинают каждый забег сгруппированными вместе</li>
      <li>
        Уменьшено количество частиц, отрисовываемых для состояния благословение и взрыва Molotov
      </li>
      <li>
        Усилена мощность снижения кровотечения Наложение швов: (20 + Level*(Le/8 + De/12)) --> (20 +
        Level*(Le/4 + De/8))
      </li>
      <li>Изменение размера окна с экрана Таверна больше не ломает вселенную</li>
      <li>Добавлена кнопка "Продать всё" в магазин</li>
      <li>Имена игроков теперь могут содержать символы из любого языка</li>
      <li>Теперь можно перемещать сумки с предметами в них.</li>
      <li>Исправлен баг расчёта полос оставшегося ОЗ команд в Таверна/Арена</li>
      <li>Исправлен баг разблокировки слотов сумок из Shop</li>
      <li>Исправлены зависания ИИ, вызванные состояниями ярость</li>
      <li>
        Исправлены баги ИИ, препятствующие дереву Support использовать Поделиться маной и Убежище
      </li>
      <li>Увеличена дальность эффекта Убежище с 2 -> 3</li>
      <li>И много других исправлений багов!</li>
    </ul>
  </div>
</template>
